module.exports = __webpack_public_path__ + "static/media/pa-1.f37b1adc.png";